import { Properties } from 'csstype';
import { compose, flexbox, system } from 'styled-system';
import { CoreUiStyleType, SpaceStyleType } from './types';

export interface FlexboxStyleProps {
  alignContent?: CoreUiStyleType<Properties['alignContent']>;
  alignItems?: CoreUiStyleType<Properties['alignItems']>;
  alignSelf?: CoreUiStyleType<Properties['alignSelf']>;
  columnGap?: SpaceStyleType;
  flex?: CoreUiStyleType<Properties['flex']>;
  flexBasis?: CoreUiStyleType<Properties['flexBasis']>;
  flexDirection?: CoreUiStyleType<Properties['flexDirection']>;
  flexGrow?: CoreUiStyleType<Properties['flexGrow']>;
  flexShrink?: CoreUiStyleType<Properties['flexShrink']>;
  flexWrap?: CoreUiStyleType<Properties['flexWrap']>;
  gap?: SpaceStyleType;
  justifyContent?: CoreUiStyleType<Properties['justifyContent']>;
  order?: CoreUiStyleType<Properties['order']>;
  rowGap?: SpaceStyleType;
}

export const flexboxStylePropNames: (keyof FlexboxStyleProps)[] = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'columnGap',
  'flex',
  'flexBasis',
  'flexDirection',
  'flexGrow',
  'flexShrink',
  'flexWrap',
  'gap',
  'justifyContent',
  'order',
  'rowGap',
];

const styledSystemDefaultScale = [0, 4, 8, 16, 32, 64, 128, 256, 512];

export const gap = system({
  gap: {
    property: 'gap',
    scale: 'space',
    defaultScale: styledSystemDefaultScale,
  },
  columnGap: {
    property: 'columnGap',
    scale: 'space',
    defaultScale: styledSystemDefaultScale,
  },
  rowGap: {
    property: 'rowGap',
    scale: 'space',
    defaultScale: styledSystemDefaultScale,
  },
});
const flexboxWithGap = compose(flexbox, gap);

export { flexboxWithGap as flexbox };
